import { HttpInterceptorFn } from '@angular/common/http';

/** Boundary and field blobs are overwritten in place, so they must never be served from cache. */
function isBlobRequest(url: string): boolean {
    return url.split('?')[0].endsWith('.bin');
}

export const BlobCacheBusterInterceptor: HttpInterceptorFn = (req, next) => {
    if (req.method !== 'GET' || !isBlobRequest(req.url)) return next(req);
    return next(req.clone({ params: req.params.set('t', String(Date.now())) }));
};
